import React from 'react';

import RoomChatPanel from '../RoomChatPanel';

function RoomChat(props) {
  return <RoomChatPanel {...props} />;
}

export default RoomChat;
